import Subheader from 'app/frontend/base/components/Subheader'
import { useGuild } from 'app/frontend/base/config/context/guild'
import { useTranslation } from 'react-i18next'

const TeamSubheader = () => {
  const { t } = useTranslation()
  const { teamReference, currentTeam } = useGuild()

  if (!teamReference) return null

  return (
    <Subheader
      menuItems={[
        {
          name: t('shared.overview'),
          path: `${teamReference.path}`,
          exact: true,
          section: 'base',
          requirement: 'member',
          width: 94,
        },
        {
          name: t('shared.events'),
          path: `${teamReference.path}/events`,
          section: 'events',
          requirement: 'member',
          width: 76,
        },
        {
          name: t('shared.loot'),
          // This path is used when this item doesn't fit and is nested under 'More'
          path: `${teamReference.path}/loot`,
          section: 'loot',
          requirement: 'member',
          width: 61,
          children: [
            {
              name: t('dashboard.team.loot.personal'),
              path: `${teamReference.path}/loot/characters`,
              section: 'loot',
              requirement:
                currentTeam?.settings.wishlistOverviewVisibility.value ===
                'entire_team'
                  ? 'member'
                  : 'admin',
            },
            {
              name: t('dashboard.team.loot.overview'),
              path: `${teamReference.path}/loot/overview`,
              section: 'loot',
              requirement: 'member',
            },
            {
              name: t('dashboard.team.loot.history'),
              path: `${teamReference.path}/loot/history`,
              section: 'loot',
              requirement:
                currentTeam?.settings.wishlistLootHistoryVisibility.value ===
                'entire_team'
                  ? 'member'
                  : 'admin',
            },
          ],
        },
        {
          name: (
            <div
              className={`flex items-center justify-center gap-1.5 md:w-[4.8rem] ${
                currentTeam?.members === undefined ? 'opacity-0' : 'opacity-100'
              }`}
            >
              <span>{t('shared.roster')}</span>
              <span className='text-muted-foreground text-xs max-md:hidden'>
                ({currentTeam?.members?.length ?? 0})
              </span>
            </div>
          ),
          path: `${teamReference.path}/roster`,
          section: 'roster',
          requirement: 'member',
          width: 75,
        },
        {
          name: t('shared.news'),
          path: `${teamReference.path}/news`,
          section: 'news',
          requirement: 'member',
          width: 69,
        },
        {
          name: (
            <div
              className={`flex items-center justify-center gap-1.5 md:w-[5.8rem] ${
                currentTeam?.members === undefined ? 'opacity-0' : 'opacity-100'
              }`}
            >
              <span>{t('shared.applicants')}</span>
              <span className='text-muted-foreground text-xs max-md:hidden'>
                ({currentTeam?.openApplicationIds?.length ?? 0})
              </span>
            </div>
          ),
          path: `${teamReference.path}/applicants`,
          section: 'applications',
          requirement: 'member',
          width: 102,
        },
        {
          name: t('shared.spreadsheet'),
          path: `${teamReference.path}/spreadsheet`,
          section: 'base',
          requirement: 'member',
          width: 116,
        },
        {
          name: t('shared.settings'),
          path: `${teamReference.path}/settings`,
          section: 'base',
          requirement: 'admin',
          width: 87,
        },
      ]}
    />
  )
}

export default TeamSubheader
